import { Col, Label, ReactSelectBox, Row, Tooltip, EventHandler } from "client/CommonComponents";
import { CONSTANTS } from "client/utils/constants";

const MowerAttribute = (props: any) => {

  const { catalogItemValues, handleOnChange, catalogItemErrors } = props

  return (
    <>
      <p className="fs-12 mb-2"><b>{`${props.assetTypeValue} Attributes`}</b></p>
      <Row>
        <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
          <div className="label-addnew-block">
            <Label required data-attribute="MowerAttribute_Default_Label">State Availability</Label>
            <EventHandler onEvent={() => {props?.onPopupFilterModel('State Availability')}} data-attribute="MowerAttribute_Default_EventHandler">
              <a className="fs-12">Add New</a>
            </EventHandler>
          </div>
          <Tooltip content={catalogItemValues?.stateAvailability?.label ?? ''} data-attribute="MowerAttribute_Default_Tooltip">
          <ReactSelectBox
            isSearchable={true}
            name='stateAvailability'
            placeholder="Select State Availability"
            options={props?.stateAvailabilityOption}
            value={catalogItemValues?.stateAvailability ?? ''}
            onChange={(selectedOption: any) => handleOnChange(selectedOption, 'stateAvailability')}
            className={catalogItemErrors?.stateAvailability ? 'controlValidation' : "" }
           data-attribute="MowerAttribute_stateAvailability_SearchSelectBox" />
          </Tooltip>
          {catalogItemErrors?.stateAvailability ? <p className='validMessage'>{catalogItemErrors?.stateAvailability}</p> : ""}
        </Col>
        {props.assetTypeValue !== CONSTANTS.STANDARIZED_EQUIPMENT ?
          <>
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="MowerAttribute_Default_Label_2">Program Status</Label>
                <EventHandler onEvent={() => {props?.onPopupFilterModel('Program Status')}} data-attribute="MowerAttribute_Default_EventHandler_2">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.programStatus?.label ?? ''} data-attribute="MowerAttribute_Default_Tooltip_2">
              <ReactSelectBox
                isSearchable={true}
                name='programStatus'
                placeholder="Select Program Status"
                options={props?.programStatusOption}
                value={catalogItemValues?.programStatus ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'programStatus')}
                className={catalogItemErrors?.programStatus ? 'controlValidation' : "" }
               data-attribute="MowerAttribute_programStatus_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.programStatus ? <p className='validMessage'>{catalogItemErrors?.programStatus}</p> : ""}
            </Col>
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="MowerAttribute_Default_Label_3">Annual Hours</Label>
                <EventHandler onEvent={() => {props?.onPopupFilterModel('Annual Hours')}} data-attribute="MowerAttribute_Default_EventHandler_3">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.annualHours?.label ?? ''} data-attribute="MowerAttribute_Default_Tooltip_3">
              <ReactSelectBox
                isSearchable={true}
                name='annualHours'
                placeholder="Select Annual Hours"
                options={props?.annualHoursOption}
                value={catalogItemValues?.annualHours ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'annualHours')}
                className={catalogItemErrors?.annualHours ? 'controlValidation' : "" }
               data-attribute="MowerAttribute_annualHours_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.annualHours ? <p className='validMessage'>{catalogItemErrors?.annualHours}</p> : ""}
            </Col>
          </> : null
        }
        {props.assetTypeValue === CONSTANTS.MOWER ?
          <>
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="MowerAttribute_Default_Label_4">Deck Size</Label>
                <EventHandler onEvent={() => {props?.onPopupFilterModel('Deck Size')}} data-attribute="MowerAttribute_Default_EventHandler_4">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.deckSize?.label ?? ''} data-attribute="MowerAttribute_Default_Tooltip_4">
              <ReactSelectBox
                isSearchable={true}
                name='deckSize'
                placeholder="Select Deck Size"
                options={props?.desckSizeOption}
                value={catalogItemValues?.deckSize ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'deckSize')}
                className={catalogItemErrors?.deckSize ? 'controlValidation' : "" }
               data-attribute="MowerAttribute_deckSize_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.deckSize ? <p className='validMessage'>{catalogItemErrors?.deckSize}</p> : ""}
            </Col>
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="MowerAttribute_Default_Label_5">Deck Type</Label>
                <EventHandler onEvent={() => {props?.onPopupFilterModel('Deck Type')}} data-attribute="MowerAttribute_Default_EventHandler_5">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.deckType?.label ?? ''} data-attribute="MowerAttribute_Default_Tooltip_5">
              <ReactSelectBox
                isSearchable={true}
                name='deckType'
                placeholder="Select Deck Type"
                options={props?.deckTypeOption}
                value={catalogItemValues?.deckType ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'deckType')}
                className={catalogItemErrors?.deckType ? 'controlValidation' : "" }
               data-attribute="MowerAttribute_deckType_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.deckType ? <p className='validMessage'>{catalogItemErrors?.deckType}</p> : ""}
            </Col>
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="MowerAttribute_Default_Label_6">Autonomous</Label>
                <EventHandler onEvent={() => {props?.onPopupFilterModel('Autonomous')}} data-attribute="MowerAttribute_Default_EventHandler_6">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.autonomous?.label ?? ''} data-attribute="MowerAttribute_Default_Tooltip_6">
              <ReactSelectBox
                isSearchable={true}
                name='autonomous'
                placeholder="Select Autonomous"
                options={props?.autonomousOption}
                value={catalogItemValues?.autonomous ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'autonomous')}
                className={catalogItemErrors?.autonomous ? 'controlValidation' : "" }
               data-attribute="MowerAttribute_autonomous_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.autonomous ? <p className='validMessage'>{catalogItemErrors?.autonomous}</p> : ""}
            </Col>
          </>
          : null
        }
      </Row>
      
      </>
  )
}

export default MowerAttribute
